import React from 'react';
import { Container } from '@mui/material';
import { Outlet } from 'react-router';
import { Snackbar } from '@/core/features/snackbar';
import { Loader } from '@/core/features/loader';

const AuthRootLayout = () => (
  <>
    <Snackbar />
    <Loader />

    <Container maxWidth={false} component="main" disableGutters>
      <Outlet />
    </Container>
  </>
);

export default AuthRootLayout;
